const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: "#ffffff",
      boxShadow: "0 8px 30px rgba(15, 23, 42, 0.055)",
      border: "1px solid #E2E8F0",
      borderRadius: 16,
      overflowX: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#CBD5E1 transparent",
      "&::-webkit-scrollbar": { height: 7, width: 7 },
      "&::-webkit-scrollbar-thumb": { background: "#CBD5E1", borderRadius: 99 },
    },
  },
};

export default tableContainer;
